import { LocalImage } from '../../primitives';

export type LogoProps = {
	variant?: 'white' | 'colored';
	className?: string;
};

export function Logo(props: LogoProps) {
	switch (props.variant) {
		case 'colored':
			return <LocalImage uri="/assets/logos/mybonus/green.svg" className={props.className} />;
		case 'white':
		default:
			return <LocalImage uri="/assets/logos/mybonus/white.svg" className={props.className} />;
	}
}
